module.exports = Ember.HTMLBars.template((function() {
  var child0 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child1 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child2 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child3 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child4 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child5 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child6 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child7 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child8 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child9 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","plain-form");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-header");
      var el3 = dom.createElement("h1");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("h2");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section settings analytics-codes-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","image-preview");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-header");
      var el3 = dom.createElement("h1");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("h2");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","feature-text");
      var el3 = dom.createElement("p");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section settings analytics-codes-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("a");
      dom.setAttribute(el6,"href","https://developers.google.com/tag-manager/enhanced-ecommerce");
      dom.setAttribute(el6,"target","_blank");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","button-block sticky");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","feature-text");
      var el3 = dom.createElement("h3");
      var el4 = dom.createTextNode("Cписок целей, которые фиксирует Смартомато");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("ul");
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-open-modal-order");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-open-modal-receipt");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-open-modal-invite");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-copy-invite-link");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-dish-click");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-open-configurator");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode("  ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-open-quick-configurator");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode("   ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-dish-add");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-show-delivery-zones");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-address-autodetect");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-click-checkout");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-click-checkout");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-finish-checkout");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-click-pay");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("li");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("span");
      dom.setAttribute(el5,"class","tag");
      var el6 = dom.createTextNode("sm-order-paid");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block, element = hooks.element;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var element0 = dom.childAt(fragment, [0]);
      var element1 = dom.childAt(element0, [0]);
      var element2 = dom.childAt(element0, [1]);
      var element3 = dom.childAt(element2, [0]);
      var element4 = dom.childAt(element3, [1]);
      var element5 = dom.childAt(element2, [1]);
      var element6 = dom.childAt(element2, [2]);
      var element7 = dom.childAt(element6, [1]);
      var element8 = dom.childAt(element7, [1]);
      var element9 = dom.childAt(element0, [2]);
      var element10 = dom.childAt(element0, [4]);
      var element11 = dom.childAt(element10, [0]);
      var element12 = dom.childAt(element11, [1]);
      var element13 = dom.childAt(element10, [1]);
      var element14 = dom.childAt(element13, [1]);
      var element15 = dom.childAt(element10, [2]);
      var element16 = dom.childAt(element15, [1]);
      var element17 = dom.childAt(element10, [3]);
      var element18 = dom.childAt(element17, [1]);
      var element19 = dom.childAt(element10, [4]);
      var element20 = dom.childAt(element19, [1]);
      var element21 = dom.childAt(element10, [5]);
      var element22 = dom.childAt(element21, [1]);
      var element23 = dom.childAt(element10, [7]);
      var element24 = dom.childAt(element23, [1]);
      var element25 = dom.childAt(element24, [1]);
      var element26 = dom.childAt(element10, [8]);
      var element27 = dom.childAt(element0, [5, 1]);
      var element28 = dom.childAt(element27, [5]);
      var element29 = dom.childAt(element27, [10]);
      var morph0 = dom.createMorphAt(dom.childAt(element1, [0]),0,0);
      var morph1 = dom.createMorphAt(dom.childAt(element1, [1]),0,0);
      var morph2 = dom.createMorphAt(dom.childAt(element3, [0]),0,0);
      var morph3 = dom.createMorphAt(element4,0,0);
      var morph4 = dom.createMorphAt(dom.childAt(element4, [1]),0,0);
      var morph5 = dom.createMorphAt(dom.childAt(element5, [0]),0,0);
      var morph6 = dom.createMorphAt(dom.childAt(element5, [1]),0,0);
      var morph7 = dom.createMorphAt(dom.childAt(element6, [0]),0,0);
      var morph8 = dom.createMorphAt(element7,0,0);
      var morph9 = dom.createMorphAt(element7,2,2);
      var morph10 = dom.createMorphAt(dom.childAt(element9, [0]),0,0);
      var morph11 = dom.createMorphAt(dom.childAt(element9, [1]),0,0);
      var morph12 = dom.createMorphAt(dom.childAt(element0, [3, 0]),0,0);
      var morph13 = dom.createMorphAt(dom.childAt(element11, [0]),0,0);
      var morph14 = dom.createMorphAt(element12,0,0);
      var morph15 = dom.createMorphAt(dom.childAt(element12, [1]),0,0);
      var morph16 = dom.createMorphAt(dom.childAt(element13, [0]),0,0);
      var morph17 = dom.createMorphAt(element14,0,0);
      var morph18 = dom.createMorphAt(dom.childAt(element14, [1]),0,0);
      var morph19 = dom.createMorphAt(dom.childAt(element15, [0]),0,0);
      var morph20 = dom.createMorphAt(element16,0,0);
      var morph21 = dom.createMorphAt(dom.childAt(element16, [1]),0,0);
      var morph22 = dom.createMorphAt(dom.childAt(element17, [0]),0,0);
      var morph23 = dom.createMorphAt(element18,0,0);
      var morph24 = dom.createMorphAt(dom.childAt(element18, [1]),0,0);
      var morph25 = dom.createMorphAt(dom.childAt(element19, [0]),1,1);
      var morph26 = dom.createMorphAt(element20,0,0);
      var morph27 = dom.createMorphAt(dom.childAt(element20, [1]),0,0);
      var morph28 = dom.createMorphAt(dom.childAt(element21, [0]),0,0);
      var morph29 = dom.createMorphAt(element22,0,0);
      var morph30 = dom.createMorphAt(dom.childAt(element22, [1]),0,0);
      var morph31 = dom.createMorphAt(dom.childAt(element23, [0]),0,0);
      var morph32 = dom.createMorphAt(element24,0,0);
      var morph33 = dom.createMorphAt(element25,0,0);
      var morph34 = dom.createMorphAt(dom.childAt(element25, [1]),0,0);
      var morph35 = dom.createMorphAt(element26,0,0);
      var morph36 = dom.createMorphAt(element26,1,1);
      var morph37 = dom.createMorphAt(dom.childAt(element27, [0]),1,1);
      var morph38 = dom.createMorphAt(dom.childAt(element27, [1]),1,1);
      var morph39 = dom.createMorphAt(dom.childAt(element27, [2]),1,1);
      var morph40 = dom.createMorphAt(dom.childAt(element27, [3]),1,1);
      var morph41 = dom.createMorphAt(dom.childAt(element27, [4]),1,1);
      var morph42 = dom.createMorphAt(element28,0,0);
      var morph43 = dom.createMorphAt(element28,4,4);
      var morph44 = dom.createMorphAt(dom.childAt(element27, [6]),1,1);
      var morph45 = dom.createMorphAt(dom.childAt(element27, [7]),1,1);
      var morph46 = dom.createMorphAt(dom.childAt(element27, [8]),1,1);
      var morph47 = dom.createMorphAt(dom.childAt(element27, [9]),1,1);
      var morph48 = dom.createMorphAt(element29,0,0);
      var morph49 = dom.createMorphAt(element29,4,4);
      var morph50 = dom.createMorphAt(dom.childAt(element27, [11]),0,0);
      var morph51 = dom.createMorphAt(dom.childAt(element27, [12]),0,0);
      inline(env, morph0, context, "t", ["settings.analytics.title"], {});
      inline(env, morph1, context, "t", ["settings.analytics.sub_title"], {});
      inline(env, morph2, context, "t", ["settings.analytics.labels.meta_title"], {});
      block(env, morph3, context, "sm-text-field", [], {"classNames": "full-width", "placeholder": get(env, context, "organization.name"), "value": get(env, context, "organization.meta_title")}, child0, null);
      inline(env, morph4, context, "t", ["settings.analytics.meta_title_caption"], {});
      inline(env, morph5, context, "t", ["settings.analytics.labels.meta_description"], {});
      block(env, morph6, context, "sm-text-area", [], {"classNames": "full-width", "placeholder": get(env, context, "organization.about"), "value": get(env, context, "organization.meta_description")}, child1, null);
      inline(env, morph7, context, "t", ["settings.analytics.labels.meta_image"], {});
      block(env, morph8, context, "sm-file-input", [], {"registerAs": get(env, context, "fileMetaImageInput"), "accept": "image", "onFileSelected": "uploadMetaImage"}, child2, null);
      element(env, element8, context, "bind-attr", [], {"style": get(env, context, "imageMetaImageStyle")});
      block(env, morph9, context, "sm-button", [], {"classNames": "medium", "textTranslation": "settings.analytics.buttons.load_meta_image", "type": "bordered-orange", "isLoading": get(env, context, "fileMetaImageIsUploading"), "action": "openMetaImageFileDialog"}, child3, null);
      inline(env, morph10, context, "t", ["settings.analytics.services.title"], {});
      inline(env, morph11, context, "t", ["settings.analytics.services.subtitle"], {});
      inline(env, morph12, context, "t", ["settings.analytics.services.feature_text"], {});
      inline(env, morph13, context, "t", ["settings.analytics.services.labels.ga"], {});
      block(env, morph14, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.analytics.placeholders.services.identificator", "value": get(env, context, "organization.google_analytics_code")}, child4, null);
      inline(env, morph15, context, "t", ["settings.analytics.services.examples.ga"], {});
      inline(env, morph16, context, "t", ["settings.analytics.services.labels.metrika"], {});
      block(env, morph17, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.analytics.placeholders.services.identificator", "value": get(env, context, "organization.yandex_metrika_code")}, child5, null);
      inline(env, morph18, context, "t", ["settings.analytics.services.examples.metrika"], {});
      inline(env, morph19, context, "t", ["settings.analytics.services.labels.gtm"], {});
      block(env, morph20, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.analytics.placeholders.services.identificator", "value": get(env, context, "organization.code_gtm")}, child6, null);
      inline(env, morph21, context, "t", ["settings.analytics.services.examples.gtm"], {});
      inline(env, morph22, context, "t", ["settings.analytics.services.labels.fb_pixel"], {});
      block(env, morph23, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.analytics.placeholders.services.identificator", "value": get(env, context, "organization.code_fb_pixel")}, child7, null);
      inline(env, morph24, context, "t", ["settings.analytics.services.examples.fb_pixel"], {});
      inline(env, morph25, context, "t", ["settings.analytics.services.labels.vk_pixel"], {});
      block(env, morph26, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.analytics.placeholders.services.identificator", "value": get(env, context, "organization.code_vk_pixel")}, child8, null);
      inline(env, morph27, context, "t", ["settings.analytics.services.examples.vk_pixel"], {});
      inline(env, morph28, context, "t", ["settings.analytics.services.labels.mail_pixel"], {});
      block(env, morph29, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.analytics.placeholders.services.identificator", "value": get(env, context, "organization.code_mail_pixel")}, child9, null);
      inline(env, morph30, context, "t", ["settings.analytics.services.examples.mail_pixel"], {});
      inline(env, morph31, context, "t", ["settings.analytics.services.labels.data_layer"], {});
      inline(env, morph32, context, "sm-toggle", [], {"checked": get(env, context, "organization.track_data_layer")});
      inline(env, morph33, context, "t", ["settings.analytics.services.data_layer_caption"], {});
      inline(env, morph34, context, "t", ["settings.analytics.services.data_layer_more"], {});
      inline(env, morph35, context, "sm-button", [], {"textTranslation": "settings.analytics.buttons.save", "isLoading": get(env, context, "isSaving"), "action": "saveOrganization"});
      inline(env, morph36, context, "sm-button", [], {"type": "gray", "textTranslation": "settings.analytics.buttons.cancel", "action": "discartChanges"});
      inline(env, morph37, context, "t", ["settings.analytics.services.events.open.modal.order"], {});
      inline(env, morph38, context, "t", ["settings.analytics.services.events.open.modal.receipt"], {});
      inline(env, morph39, context, "t", ["settings.analytics.services.events.open.modal.invite"], {});
      inline(env, morph40, context, "t", ["settings.analytics.services.events.copy_invite"], {});
      inline(env, morph41, context, "t", ["settings.analytics.services.events.dish_click"], {});
      inline(env, morph42, context, "t", ["settings.analytics.services.events.open.configurator"], {});
      inline(env, morph43, context, "t", ["settings.analytics.services.events.open.quick_configurator"], {});
      inline(env, morph44, context, "t", ["settings.analytics.services.events.dish_add"], {});
      inline(env, morph45, context, "t", ["settings.analytics.services.events.show_delivery_zones"], {});
      inline(env, morph46, context, "t", ["settings.analytics.services.events.address_autodetect"], {});
      inline(env, morph47, context, "t", ["settings.analytics.services.events.click_checkout.event"], {});
      inline(env, morph48, context, "t", ["settings.analytics.services.events.click_checkout.description.no_valid"], {});
      inline(env, morph49, context, "t", ["settings.analytics.services.events.click_checkout.description.and"], {});
      inline(env, morph50, context, "t", ["settings.analytics.services.events.click_pay"], {});
      inline(env, morph51, context, "t", ["settings.analytics.services.events.order_paid"], {});
      return fragment;
    }
  };
}()));